<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-icon @click="reset()" v-on="on">mdi-plus-circle</v-icon>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Add an entry</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <v-combobox
            :items="strainNames"
            @change="findType()"
            v-model="cultivar"
            label="Cultivar / Strain"
            :rules="[v => !!v || 'Item is required']"
            required
          ></v-combobox>

          <v-text-field
            v-model="brand"
            label="Brand"
            :rules="[v => !!v || 'Item is required']"
            required
          ></v-text-field>

          <v-select
            v-model="type"
            :items="items"
            label="Type"
            :rules="[v => !!v || 'Item is required']"
            required
          ></v-select>
          <v-menu
            v-model="calMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            required
          >
            <template v-slot:activator="{ on }">
              <v-text-field 
                v-model="selectedDate"
                label="Acquired" v-on="on" 
                :rules="[v => !!v || 'Item is required']"
            ></v-text-field>
            </template>
            <v-date-picker v-model="selectedDate" @input="calMenu = false" :max="nowDate"></v-date-picker>
          </v-menu>

          <v-text-field
            v-model="alias"
            label="Alias"
            :rules="[v => !!v || 'Item is required']"
            required
          ></v-text-field>
          <v-input :value="rating" :rules="[v => !!v || 'Item is required']" required>
            <v-rating v-model="rating" ></v-rating>
          </v-input>
          
          <br />
          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="submit(), dialog=false"
          >Sumbit</v-btn>
          <v-btn color="warning" @click="dialog=false">Close</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { db } from "../db";
import { strainNames } from "../assets/strains"
export default {
  data: () => ({
    dialog: false,
    valid: true,
    lazy: false,
    cultivar: "",
    brand: "",
    type: null,
    alias: "",
    items: ["Indica", "Hybrid (Indica)", "Hybrid", "Hybrid (Sativa)", "Sativa"],
    rating: null,
    selectedDate: null,
    nowDate: new Date().toISOString().substr(0, 10),
    calMenu: false,
    strainNames: strainNames.map(strain => strain.name),
  }),
  methods: {
    submit() {
      var obj = {
        cultivar: this.cultivar,
        "parentage / breeder": this.brand,
        type: this.type,
        rating: this.rating,
        acquired: this.selectedDate,
        alias: this.alias,
      };
      this.$emit("newEntry", obj);
      db.collection("strains").add(obj)
        .catch(function(err) {
          console.log(err.message)
          alert("Your form inputs are invalid. " + err.message)
        })
    },
    reset() {
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.rating = null;
      } else {
        console.log("no form to reset");
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    findType: function(){
      if (strainNames.find(strain => strain.name === this.cultivar)) {
        this.type = strainNames.find(strain => strain.name === this.cultivar).category;
      } else {
        console.log("No matching strain in databse.")
      }
    }
  }
};
</script>